import React from 'react';
import Like from '../../../assets/images/SurveyThumbUp.svg';
import Select from 'react-select';
import { pulseSurveyPageData } from '../../../utils/pageContent';

function SurveyApprovalModal({ adminList, handleChange, handleSendSurveyWithApproval, error }) {
  const superAdminListOptions = adminList.map((admin) => {
    return {
      value: admin?.id,
      label: admin?.name?.charAt(0)?.toUpperCase() + admin?.name?.slice(1)
    };
  });
  const modalData = pulseSurveyPageData.approvalModalData;

  return (
    <div className="flex justify-center items-center z-50 fixed h-screen w-screen top-0 left-0 bg-black/15 sm:px-10 px-4">
      <div className="h-fit md:w-[692px] sm:w-[500px] w-[calc(100% - 2rem)] rounded-[24px] p-8 sm:px-24 sm:py-16 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor dark:border-none border-[1.5px] border-shoorah-borderGray">
        <div className="flex justify-center">
          <img src={Like} alt="Like" />
        </div>
        <h1 className="text-2xl font-medium text-center mt-6">
          {modalData.unableToShareThisSurveyMessage}
        </h1>
        <p className="text-base font-normal text-center mt-4">
          {modalData.sendSurveyToAdminMessage}
        </p>
        <Select
          options={superAdminListOptions}
          className="mt-4 md:w-96 mx-auto dark:hidden block"
          placeholder={modalData.selectAdminPlaceholder}
          onChange={(e) => handleChange(e)}
        />
        <Select
          options={superAdminListOptions}
          className="mt-4 md:w-96 mx-auto dark:block hidden"
          placeholder={modalData.selectAdminPlaceholder}
          onChange={(e) => handleChange(e)}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              height: '40px',
              border: 'none',
              backgroundColor: '#27264D',
              borderRadius: '0.5rem',
              color: '#E5EAF9'
            }),
            menu: (baseStyles) => ({
              ...baseStyles,
              backgroundColor: '#27264D',
              borderRadius: '0.5rem'
            }),
            option: (baseStyles, { isFocused, isSelected }) => ({
              ...baseStyles,
              backgroundColor: isSelected ? '' : isFocused ? '#27264D' : '#27264D',
              color: '#E5EAF9',
              ':hover': {
                backgroundColor: '#171D2F'
              }
            }),
            singleValue: (baseStyles) => ({
              ...baseStyles,
              color: '#E5EAF9'
            }),
            dropdownIndicator: (baseStyles) => ({
              ...baseStyles,
              color: '#E5EAF9'
            })
          }}
        />
        {error && <p className="text-red-500 md:w-96 mx-auto text-sm">{error}</p>}
        <button
          className="bg-[#4A57DA] rounded-full px-10 py-3 text-white text-lg block mx-auto mt-8"
          onClick={() => handleSendSurveyWithApproval()}
        >
          {modalData.sendrequestBtnText}
        </button>
      </div>
    </div>
  );
}

export default SurveyApprovalModal;